
<template>
  <!-- // v-show="activeRoomId!=''" -->
  <div
    v-show="activeRoomId!='' && roomDetail.title!=''"
    class="col-lg-3 message-view chat-profile-view chat-sidebar"
    id="task_window"
  >
    <div class="chat-window video-window">
      <div class="tab-content chat-contents">
        <div class="content-full tab-pane show active" id="profile_tab">
          <div class="display-table">
            <div class="table-row">
              <div class="table-body">
                <div class="table-content">
                  <div class="chat-profile-img">
                    <div class="edit-profile-img">
                      <img
                        src="@/assets/profiles/avatar-02.jpg"
                        alt
                        v-if="roomDetail.room_photo==''"
                      />
                      <img v-lazy="roomDetail.room_photo" alt v-else />
                      <!-- <span class="change-img">Change Image</span> -->
                    </div>
                    <h3 class="user-name m-t-10 mb-0">{{roomDetail.room_title}}</h3>
                    <small class="text-muted">{{roomDetail.provider}}</small>
                  </div>
                  <div class="chat-profile-info">
                    <ul class="user-det-list">
                      <li v-if="roomDetail.is_group==0">
                        <span>Phone:</span>
                        <span
                          class="float-right text-muted"
                        >{{getWhatsappNumberFromJid(roomDetail.room_number)}}</span>
                      </li>
                    </ul>
                  </div>
                  <hr />
                  <div>
                    <ul class="user-det-list">
                      <li>
                        <b>Tags</b>
                      </li>
                      <li>
                        <tags-assign
                          :getWhatsappNumberFromJid="getWhatsappNumberFromJid"
                          :roomDetail="roomDetail"
                        />
                      </li>
                    </ul>
                  </div>
                  <div class="transfer-files">
                    <ul class="nav nav-tabs nav-tabs-solid nav-justified mb-0">
                      <li class="nav-item">
                        <a class="nav-link active" href="#all_files" data-toggle="tab">
                          All
                          Files
                        </a>
                      </li>
                    </ul>
                    <div class="tab-content">
                      <div class="tab-pane show active" id="all_files">
                        <ul class="files-list">
                          <li v-for="row in groupMessageMediaFile" :key="row.message_media">
                            <div class="files-cont">
                              <div class="file-type">
                                <a
                                  :href="row.message_media"
                                  target="_blank"
                                  v-if="row.message_type=='document'"
                                >
                                  <i class="fa fa-file"></i>
                                  {{getExt(row.message_media)}}
                                </a>
                                <span
                                  class="file-date"
                                  v-if="row.message_type=='document'"
                                >{{row.media_size}}</span>
                              </div>
                              <div class="files-info">
                                <span class="file-name text-ellipsis">
                                  <small v-if="row.from_me==1">You</small>
                                  <small v-else>{{row.message_name}}</small>
                                </span>

                                <span class="file-date">{{row.timeISODatetime}}</span>
                              </div>
                              <ul class="files-action">
                                <li class="dropdown dropdown-action">
                                  <a
                                    href
                                    class="dropdown-toggle"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i class="material-icons">more_horiz</i>
                                  </a>
                                  <div class="dropdown-menu">
                                    <a
                                      class="dropdown-item"
                                      @click.prevent="downloadItem(row.message_media,row.message_name)"
                                    >Download</a>
                                    <!-- <a
                                      class="dropdown-item"
                                      href="#"
                                      data-toggle="modal"
                                      data-target="#share_files"
                                    >Share</a>-->
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </li>
                          <li v-for="(row,index) in groupMessageMedia" :key="index">
                            <div class="files-cont">
                              <div class="file-type">
                                <a
                                  href
                                  @click.prevent="clickLightBox(row.message_media)"
                                  v-if="row.message_type=='image'"
                                >
                                  <img style="width:25px;" v-lazy="row.message_media" />
                                </a>
                                <a
                                  :href="row.message_media"
                                  target="_blank"
                                  v-if="row.message_type=='document'"
                                >
                                  <i class="fa fa-file"></i>
                                  {{getExt(row.message_media)}}
                                </a>
                                <span
                                  class="file-date"
                                  v-if="row.message_type=='document'"
                                >{{row.media_size}}</span>
                              </div>
                              <div class="files-info">
                                <span class="file-name text-ellipsis">
                                  <small v-if="row.from_me==1">You</small>
                                  <small v-else>{{row.message_name}}</small>
                                </span>

                                <span class="file-date">{{row.timeISODatetime}}</span>
                              </div>
                              <ul class="files-action">
                                <li class="dropdown dropdown-action">
                                  <a
                                    href
                                    class="dropdown-toggle"
                                    data-toggle="dropdown"
                                    aria-expanded="false"
                                  >
                                    <i class="material-icons">more_horiz</i>
                                  </a>
                                  <div class="dropdown-menu">
                                    <a
                                      class="dropdown-item"
                                      @click.prevent="downloadItem(row.message_media,row.message_name)"
                                    >Download</a>
                                    <!-- <a
                                      class="dropdown-item"
                                      href="#"
                                      data-toggle="modal"
                                      data-target="#share_files"
                                    >Share</a>-->
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Sidebar -->
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { getWhatsappNumberFromJid } from "@/utils/helper";
import TagsAssign from "./components/tagsAssign.vue";
export default {
  components: {
    TagsAssign
  },
  data() {
    return {
      roomDetail: {
        room_title: "",
        provider: "",
        room_photo: "",
        update_datetime: 0,
        room_number: 0,
        is_group: 0
      }
    };
  },
  watch: {
    activeRoomId: {
      handler: function(val, oldVal) {
        // console.log("right:oldVal", oldVal);
        // console.log("right:newVal", val);
        // if (oldVal != val && val != null) {
        //   this.getRoomList();
        // }
        // this.addNewRoom(val);
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["activeRoomId", "getRoomById"]),
    groupMessageMedia() {
      // return [];
      return this.$store.state.omniroom.groupMessageMedia.reverse();
    },
    groupMessageMediaFile() {
      // return [];
      return this.$store.state.omniroom.groupMessageMediaFile.reverse();
    }
  },
  methods: {
    replaceName(name) {
      return name.replace(" ", "_");
    },
    getExt(filename) {
      return filename.split(".").pop();
    },
    downloadItem(url, label) {
      axios({
        url: url,
        method: "GET",
        responseType: "blob" // important
      }).then(response => {
        if (!window.navigator.msSaveOrOpenBlob) {
          // BLOB NAVIGATOR
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "download_" + this.replaceName(label) + "." + this.getExt(url)
          );
          document.body.appendChild(link);
          link.click();
        } else {
          // BLOB FOR EXPLORER 11
          const url = window.navigator.msSaveOrOpenBlob(
            new Blob([response.data]),
            "download.pdf"
          );
        }
      });
    },
    getWhatsappNumberFromJid(jid) {
      return getWhatsappNumberFromJid(jid);
    },
    clickLightBox(message_media) {
      // console.log("message_media", message_media);
      this.$root.$emit("openGallery", message_media);
    }
  },
  async created() {
    this.$root.$on("switchRoom", async roomArr => {
      // console.log("right rooomo", roomArr);
      // console.log(this.$store.getters.getRoomById(roomArr.room_id));
      this.roomDetail = this.$store.getters.getRoomById(roomArr.room_id);
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/views/omni/RightSidebar.vue